import React, { useContext } from 'react'
import styles from './../../../../assets/styles/componentStyles/manychatStyles/leftSectionComponent.module.scss'
import { Grid } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext';
import WorkflowFormHeader from './workflowFormHeader';
import WorkflowFormBody from './workflowFormBody';
import NewContentBlocks from './components/newContentBlocks';
import formStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import workflowStyles from "../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss"
import TriggerDeploymentInfo from './triggerDeploymentInfo';
import BasicWorkflowDetails from './components/basicWorkflowDetails';
import { primaryColor } from '../../../../utils/colors';
import { handleLeftPanel } from '../flowBuilderConstants';

const LeftSectionComponent = (props: any) => {
    const { currentActiveNodeConfig, setCurrentActiveNodeConfig, nodes } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    
    return (
        <Grid item sx={{ height: "100%" }} className={`${styles.absoultePositioningStyle} ${currentActiveNodeConfig.flagOpenConfigForm ? styles.openPositioningStyle : styles.closePositioningStyle}`}>
            <Grid container sx={{ height: "100%" }} flexWrap={"nowrap"}>

                <Grid item className={`${styles.instaGlobalSectionLeftItem} ${currentActiveNodeConfig.flagOpenConfigForm ? styles.open : styles.close}`}>
                    {
                        currentActiveNodeConfig.nodeId && nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId)?.data?.length > 0 ?
                            <Grid container direction={"column"} gap={1} sx={{ height: "100%" }} flexWrap={"nowrap"}>
                                <WorkflowFormHeader headingName="Send Message" />
                                <WorkflowFormBody />
                            </Grid>
                            :
                            currentActiveNodeConfig?.flag_initial ?
                                <Grid container direction={"column"} gap={1} sx={{ height: "100%" }} flexWrap={"nowrap"}>
                                    <WorkflowFormHeader headingName="Send Message" />
                                    <Grid item className={formStyles.bodyFormComponents}>
                                        <Grid container direction={"column"} gap={2}>
                                            <Grid item>
                                                <Grid container direction={"column"} gap={"10px"}>
                                                    <Grid item sx={{ width: "100%" }} className={formStyles.contentBlockSubHeadingStyle}>
                                                        Add one of the content blocks:
                                                    </Grid>
                                                    <Grid item sx={{ width: "100%" }}>
                                                        <NewContentBlocks />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                :
                                currentActiveNodeConfig?.flag_trigger ?
                                    <Grid container direction={"column"} gap={1} sx={{ height: "100%" }} flexWrap={"nowrap"}>
                                        <WorkflowFormHeader headingName="Trigger Event" />
                                        <TriggerDeploymentInfo />
                                    </Grid>
                                    :
                                    <BasicWorkflowDetails />

                    }
                </Grid>

                {!currentActiveNodeConfig.flagOpenConfigForm && 
                    <Grid item
                        alignSelf={"center"} padding={"0px 15px"}
                        sx={{ cursor: "pointer", display: "flex", height: "100%", alignItems: "center", zIndex: "5 !important", backgroundColor: "rgba(0,0,0,0.04)", transition: "all 0.3s ease", "&:hover": { backgroundColor: "rgba(0,0,0,0.08)" } }}
                        onClick={() => handleLeftPanel(setCurrentActiveNodeConfig)}
                    >
                        <ArrowBackIosNewIcon className={workflowStyles.leftSectionArrowIconForClose} sx={{ transform: currentActiveNodeConfig.flagOpenConfigForm ? "" : "rotate(180deg)", }} />
                    </Grid>
                }

            </Grid>
        </Grid>
    )
}

export default LeftSectionComponent
